var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('AdminPageHeader',{attrs:{"header":_vm.$t('account.card.add')}}),_c('div',{staticClass:"content",attrs:{"id":"content"}},[_c('b-card',[_c('resource-form',{on:{"saved":_vm.returnBack,"cancelled":_vm.returnBack}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }